"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.afto781V1AircrewDataSchema = exports.afto781V1AircrewDataFlightConditionsSchema = exports.afto781V1AircrewDataFlightConditionsCombatSptSchema = exports.afto781V1AircrewDataFlightConditionsCombatSchema = exports.afto781V1AircrewDataFlightTimeSchema = exports.afto781V1AircrewDataFlightTimeTotalsSchema = void 0;
const yup = __importStar(require("yup"));
exports.afto781V1AircrewDataFlightTimeTotalsSchema = yup.object().shape({
    time: yup.number().nullable().optional(),
    srty: yup.number().nullable().optional(),
});
exports.afto781V1AircrewDataFlightTimeSchema = yup.object().shape({
    prim: yup.number().nullable().optional(),
    sec: yup.number().nullable().optional(),
    instr: yup.number().nullable().optional(),
    eval: yup.number().nullable().optional(),
    other: yup.number().nullable().optional(),
    totals: exports.afto781V1AircrewDataFlightTimeTotalsSchema.nullable().optional(),
});
exports.afto781V1AircrewDataFlightConditionsCombatSchema = yup
    .object()
    .shape({
    time: yup.number().nullable().optional(),
    srty: yup.number().nullable().optional(),
});
exports.afto781V1AircrewDataFlightConditionsCombatSptSchema = yup
    .object()
    .shape({
    time: yup.number().nullable().optional(),
    srty: yup.number().nullable().optional(),
});
exports.afto781V1AircrewDataFlightConditionsSchema = yup.object().shape({
    night: yup.number().nullable().optional(),
    ins: yup.number().nullable().optional(),
    simIns: yup.number().nullable().optional(),
    nvg: yup.number().nullable().optional(),
    combat: exports.afto781V1AircrewDataFlightConditionsCombatSchema.nullable().optional(),
    combatSpt: exports.afto781V1AircrewDataFlightConditionsCombatSptSchema.nullable().optional(),
});
exports.afto781V1AircrewDataSchema = yup.object().shape({
    userId: yup.string().nullable().optional(),
    flightTime: exports.afto781V1AircrewDataFlightTimeSchema.nullable().optional(),
    flightConditions: exports.afto781V1AircrewDataFlightConditionsSchema.nullable().optional(),
});
